import { render, staticRenderFns } from "./phoneinput.vue?vue&type=template&id=77806880&scoped=true"
import script from "./phoneinput.vue?vue&type=script&lang=js"
export * from "./phoneinput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77806880",
  null
  
)

export default component.exports